import { apiFetch, readErrorMessage, readJson } from './client';

export interface AnalyticsReadinessCheck {
  status: string;
  description?: string;
  durationMs?: number;
}

export interface AnalyticsReadiness {
  status: string;
  service: string;
  totalDurationMs?: number;
  checks: Record<string, AnalyticsReadinessCheck>;
}

export interface MetadataAdminSyncCounts {
  pending: number;
  synced: number;
  failed: number;
}

export interface MetadataAdminDatasetStatus {
  datasetId: string;
  name: string;
  syncState: number;
  syncFailureReason?: string | null;
  lastSyncedUtc?: string | null;
}

export interface MetadataAdminResponse {
  openMetadataStatus: string;
  openMetadataDescription: string;
  botTokenConfigured: boolean;
  openMetadataUrl?: string | null;
  accessGuidance?: string | null;
  counts: MetadataAdminSyncCounts;
  attention: MetadataAdminDatasetStatus[];
}

export async function getAnalyticsReadiness(): Promise<AnalyticsReadiness> {
  const res = await apiFetch('/api/analytics/health/ready');
  if (!res.ok) throw new Error(await readErrorMessage(res));
  return readJson<AnalyticsReadiness>(res);
}

export async function getOpenMetadataAdmin(): Promise<MetadataAdminResponse> {
  const res = await apiFetch('/api/analytics/admin/metadata');
  if (!res.ok) throw new Error(await readErrorMessage(res));
  return readJson<MetadataAdminResponse>(res);
}

export async function retryDatasetMetadataSync(datasetId: string): Promise<void> {
  const res = await apiFetch(`/api/analytics/datasets/${datasetId}/metadata/sync`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ datasetId })
  });
  if (!res.ok) throw new Error(await readErrorMessage(res));
}
